<template>
    <div class='main'>
        <div class="header">
            <div class="header-title">
                <h4>行事一覧</h4>
                <p>販売中の行事から選択できます</p>
            </div>
            <button class='button is-info is-medium add-button' @click='open'>＋ 行事新規追加</button>
        </div>
        <div v-if='events && events.length > 0' class='events'>
            <div v-for='event in events' :key='event.id' class="event-card-wrapper" @click='detail(event.id)'>
                <div class='event-card'>
                    <!-- <img v-if='event.thumbnail' :src='`${photoBaseUrl}/${event.thumbnail}`'>
                    <img v-else :src='`${photoBaseUrl}/assets/l_e_others_501.png`'> -->
                    <div class="card-content">
                        <div>
                            <div class="title-row">
                                <h5 class="event-title"> {{ event.name }} </h5>
                                <span v-if='event.sales_outside_period' class='status-badge status-badge--outside'>期間外販売中</span>
                                <span v-else-if='event.sales' class='status-badge status-badge--on'>販売中</span>
                                <span v-else class='status-badge status-badge--off'>販売期間外</span>
                            </div>
                            <p class='meta'> {{ schoolMap[event.school_id].name }} - {{ yearMap[event.year_id].name }} </p>
                            <time class="date-range"> {{ event.start_date }} ~ {{ event.end_date }} </time>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class='events'>
            上記ボタンより行事を登録してください
        </div>
        <div class="modal" :class='{ "is-active": isActive }'>
            <div class="modal-background" @click='close'></div>
            <div class="modal-card">
                <section class="modal-card-body">
                    <div class="field">
                        <p class="control has-icons-left has-icons-right">
                            <input v-model='id' class="input" type="text" placeholder="行事ID">
                            <span class="icon is-small is-left">
                                <i class="fas fa-id-card"></i>
                            </span>
                        </p>
                    </div>
                    <div class="field">
                        <p class="control has-icons-left">
                            <input v-model='password' class="input" type="text" placeholder="パスワード">
                            <span class="icon is-small is-left">
                                <i class="fas fa-lock"></i>
                            </span>
                        </p>
                    </div>
                </section>
                <footer class="modal-card-foot">
                <button class="button" @click='close'>閉じる</button>
                <button class="button is-success" @click='add'>追加</button>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'EventManage',
    props: [],
    components: {
    },
    data () {
        return {
            photoBaseUrl: process.env.PHOTO_BASE_URL,
            originEvents: [],
            schoolMap: {},
            yearMap: {},
            isActive: false,
            id: '',
            password: ''
        }
    },
    computed: {
        events () {
            const self = this
            let events = self.originEvents.map((event) => {
                let startDate, endDate
                if (event.sales_start_date) {
                    startDate = new Date(event.sales_start_date)
                    endDate = new Date(event.sales_end_date)
                } else {
                    startDate = new Date('1970-01-01')
                    endDate = new Date('1970-01-01')
                }
                event.sales = false
                const now = new Date()
                endDate.setDate(endDate.getDate() + 1)

                if ((startDate <= now && now <= endDate) || event.sales_outside_period) {
                    endDate.setDate(endDate.getDate() - 1)
                    event.sales = true
                    event.start_date = self.formatDate(startDate)
                    event.end_date = self.formatDate(endDate)
                    return event
                }
                return null
            })

            return events.filter((event) => {
                return event && event.sales
            })
        }
    },
    mounted () {
        const self = this
        self.axios.get(`${process.env.API_URL}/photobuy/events`).then((res) => {
            self.originEvents = res.data.events
            self.schoolMap = res.data.schoolMap
            self.yearMap = res.data.yearMap
        }).catch((e) => {
            alert('サーバーに問題が発生しています')
        })
    },
    methods: {
        open () {
            this.isActive = true
        },
        close () {
            this.isActive = false
        },
        add () {
            const self = this

            self.axios.post(`${process.env.API_URL}/photobuy/event`, {
                browsingId: self.id,
                password: self.password
            }).then((res) => {
                if (res.data.message === 'OK') {
                    self.$router.go({path: self.$router.currentRoute.path, force: true})
                    if (res.data.alreadyAdded) {
                        self.$root.$emit('notification', 'is-primary', 'この行事は既に追加されています。行事一覧からご確認ください')
                    } else {
                        self.$root.$emit('notification', 'is-primary', '行事の追加に成功しました')
                    }
                } else if (res.data.message === 'Duplicate') {
                    // 後方互換: 旧APIレスポンスへの対応
                    self.$router.go({path: self.$router.currentRoute.path, force: true})
                    self.$root.$emit('notification', 'is-primary', 'この行事は既に追加されています。行事一覧からご確認ください')
                } else {
                    self.close()
                    self.$root.$emit('notification', 'is-danger', '行事の追加に失敗しました ID または パスワードが間違っている可能性があります')
                }
            }).catch((e) => {
                console.log(e)
                alert('サーバーに問題が発生しています')
            })
        },
        formatDate (date) {
            var y = date.getFullYear()
            var m = ('00' + (date.getMonth() + 1)).slice(-2)
            var d = ('00' + date.getDate()).slice(-2)
            return (y + '-' + m + '-' + d)
        },
        detail (eventId) {
            this.$router.push(`/photobuy/event/${eventId}`)
        }
    }
}
</script>

<style scoped>

.main {
    margin-bottom: 30px;
    padding-right: 40px;
}

.header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
}

.header-title h4 {
    font-size: 18px;
    font-weight: 700;
    margin: 0;
}

.header-title p {
    margin: 4px 0 0;
    font-size: 15px;
    color: #666;
}

.button {
    width: calc(100% - 20px);
}

.add-button {
    width: auto;
    padding: 12px 20px;
    font-size: 16px;
    font-weight: 700;
    border-radius: 10px;
    background: #1f7ae0;
    border-color: #1f7ae0;
    color: #fff;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
    letter-spacing: 0.02em;
}

.add-button:hover {
    background: #1a6cc7;
    border-color: #1a6cc7;
}

.events {
    margin-top: 70px;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 16px;
}

.event-card-wrapper {
    width: 100%;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    background: #fff;
    transition: transform 0.12s ease, box-shadow 0.12s ease;
}

.event-card-wrapper:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.08);
}

.event-card {
    cursor: pointer;
}

.title-row {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

img {
    width: 100%;
}

.event-title {
    font-size: 21px;
    font-weight: 700;
    margin: 0;
}

.meta {
    margin: 6px 0 0;
    color: #555;
    font-size: 16px;
}

.date-range {
    display: block;
    margin-top: 8px;
    font-size: 15px;
    color: #777;
}

.status-badge {
    display: inline-flex;
    align-items: center;
    padding: 3px 8px;
    border-radius: 999px;
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0.02em;
}

.status-badge--on {
    background: #e6f6ed;
    color: #1a7f37;
}

.status-badge--outside {
    background: #fff3d6;
    color: #a15c00;
}

.status-badge--off {
    background: #f1f1f1;
    color: #777;
}

@media screen and (max-width: 1150px) {
    .events {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (max-width: 600px) {
    .header {
        flex-direction: column;
        align-items: flex-start;
    }

    .add-button {
        width: 100%;
    }

    .events {
        margin-top: 20px;
        grid-template-columns: 1fr;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/photobuy/pages/EventManage.vue